import React from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";

const MetricView = (props) => {
  return (
    <div>
      <div className="overview-fph">
        <Heading level={3} type="h300" alignment="left">
          <FormattedMessage
            id={props.data.title}
            defaultMessage={props.data.message}
          />
        </Heading>
      </div>
      <Text type="d50">{props.data.value}</Text>
    </div>
  );
};

export default MetricView;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/MetricView.js